import { TextField } from '@calendly/form';
import { object, string } from '@calendly/form/validation';
import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { useRef, useEffect, forwardRef } from 'react';
import { isNoTouchDevice } from 'services/touch_device_detection';
import { AdditionalInfo } from './additional_info';
import { CustomLocationPopup } from './custom_location_popup';
const textFieldContainerCss = "toerrua";
const TextFieldContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(textFieldContainerCss, props.className)} />;
});
export const PhysicalPopup = () => {
  const ref = useRef(null);
  useEffect(() => ref.current?.focus(), []);
  const validationSchema = object({
    location: string().trim().required(I18n.t('publisher.event_types.location.physical_location_required')),
    additionalInfo: string().trim(),
    hideLocation: string().required().oneOf(['hidden', 'visible'])
  });
  return <CustomLocationPopup validationSchema={validationSchema}>
      <TextFieldContainer ref={ref}>
        <TextField aria-label={I18n.t('publisher.event_types.location.physical_location_label')} autoFocus={isNoTouchDevice()} name="location" />
      </TextFieldContainer>
      <AdditionalInfo />
    </CustomLocationPopup>;
};

require("./physical_popup.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./physical_popup.js");